import type { InitOptions } from "i18next";
import en from "locales/en/translation.json";
import el from "locales/el/translation.json";

export const i18nConfig: InitOptions = {
  supportedLngs: ["en", "el"],
  fallbackLng: "en",
  defaultNS: "common",
  // Disabling suspense is recommended
  react: { useSuspense: false },
  resources: {
    en: {
      common: en,
    },
    el: {
      common: el,
    },
  },
};
